export function BulkDelete(organizationID: number): string {
	return `/v1/organizations/${organizationID}/bookings`;
}

export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/bookings`;
}

export function Delete(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/bookings/${ID}`;
}

export function Groups(organizationID: number): string {
	return `/v1/organizations/${organizationID}/bookings/groups`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/bookings`;
}

export function Update(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/bookings/${ID}`;
}

